import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

import { IUiNotificationService } from '../../interfaces';
import { UiNotificationType } from '../../models';

@Injectable()
export class HttpNoContentHandlerService implements HttpInterceptor {
    constructor(@Inject('IUiNotificationService') private uiNotificationService: IUiNotificationService,) {
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        return next.handle(request).pipe(
            map(response => {
                if (response instanceof HttpResponse &&
                    response.status === 204 &&
                    request.method === 'GET') {
                    this.uiNotificationService.showNotification(
                        UiNotificationType.Info,
                        "No content");
                }

                return response;
            }),
        );
    }
}